import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/sales/src/environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

const BASE_URL_SALES = environment.saleApiUrl;
const BASE_URL_MASTER = environment.masterApiURL;
export interface PODS_LIST_TO_REFRESH {
  MD_pod?: boolean; //my day
  notif_pod?: boolean;
  
  LeadStats_pod?: boolean; // Leads Stats
  PropStats_pod?: boolean; // Proposal Stats
  OppStats_pod?: boolean; // Opportunities Stats
  SOStats_pod?: boolean; // Sales Orders Stats
  
  // SO Pods
  COL_pod?: boolean; // Currently On Leave
  PV_pod?: boolean; // Pending Vacations
  SOAA_pod?: boolean; // Sales Order Awaiting Approval
  SORTBP_pod?: boolean; // Sales Order Ready To Be Published
  SOWUCSAP_pod?: boolean; // Sales Orders With Unassigned CSA Publisher Pod
  SOUPCA_pod?: boolean; // Sales Order With Unassigned PCA
  USO_pod?: boolean; // Unlinked Sales Order Pod

  //Leads Pods
  NL_pod?: boolean; // New Leads
  UL_pod?: boolean; // Unassigned Leads
}
@Injectable({
  providedIn: 'root'
})
export class HomeService {


  // private refreshCOLPod = new BehaviorSubject<boolean>(false);
  private refreshPodsList = new Subject<PODS_LIST_TO_REFRESH>();
  constructor(private http: HttpClient) { }
  hitRefreshPods(pods: PODS_LIST_TO_REFRESH) {
    const LIST: PODS_LIST_TO_REFRESH = { COL_pod: false, LeadStats_pod: false, MD_pod: false, NL_pod: false, notif_pod: false, OppStats_pod: false, PropStats_pod: false, PV_pod: false, SOStats_pod: false, SOAA_pod: false, SORTBP_pod: false, SOUPCA_pod: false, SOWUCSAP_pod: false, UL_pod: false };
    Object.entries(pods).forEach(([key, val]: any) => LIST[key] = val);
    this.refreshPodsList.next(LIST);
  }
  listendPodsRefeshingSubject() {
    return this.refreshPodsList;
  }

  getLeadsStat(district: any, region: any) {
    return this.http.get(`${BASE_URL_MASTER}dashboard/GetLeadStat?$count=true&district=${district}&region=${region}`);
  }
  getOpportunitiesStat(district: any, region: any) {
    return this.http.get(`${BASE_URL_MASTER}dashboard/GetOpportunityStat?$count=true&district=${district}&region=${region}`);
  }
  getProposalStat(district: any, region: any) {
    return this.http.get(`${BASE_URL_MASTER}dashboard/GetProposalStat?$count=true&district=${district}&region=${region}`);
  }
  getSalesOrdersStat(district: any, region: any) {
    return this.http.get(`${BASE_URL_MASTER}dashboard/GetSalesOrderStat?$count=true&district=${district}&region=${region}`);
  }




  dismissNotification(notificationId: string) {
    return this.http.post(`${BASE_URL_MASTER}dashboard/DismissNotification?notificationId=${notificationId}`, {});
  }


  getNotifications(id: string, isTechnician?: boolean) {
    return this.http.get(`${BASE_URL_MASTER}Dashboard/GetNotifications?employeId=${id}`);
    // if (isTechnician) {
    //     return this.http.get(`${BASE_URL_MASTER}Dashboard/GetNotifications?employeId=${id}`);
    // } else {
    //     return this.http.get(`${BASE_URL_MASTER}Dashboard/GetManagerNotifications?employeId=${id}`);
    // }
  }


  getModulesWithNotifications() {
    return this.http.get(`${BASE_URL_MASTER}dashboard/GetModuleForNotifications?$count=true`);
  }
  markNotificationAsRead(notificationId: string) {
    return this.http.post(`${BASE_URL_MASTER}dashboard/MarkNotificationAsRead?notificationId=${notificationId}`, {});
  }
}
